module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zskf-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("尊贵的会员：\n      "), _c('div', {
    staticClass: "des-inline"
  }, [_c('p', {
    staticClass: "des-in"
  }, [_vm._v("遇到问题怎么办？")]), _vm._v(" "), _c('p', {
    staticClass: "des-in"
  }, [_vm._v("新功能不理解？不会用？")]), _vm._v(" "), _c('p', {
    staticClass: "des-light"
  }, [_vm._v("开通会员即刻享受58专属客服，保证24小时内解答您的疑问？")])])]), _vm._v(" "), _c('div', {
    staticClass: "zskf-bg"
  }, [_c('img', {
    staticClass: "zskf-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-zskf.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("尊贵的会员：\n      "), _c('div', {
    staticClass: "des-inline"
  }, [_c('p', {
    staticClass: "des-in"
  }, [_vm._v("网页版暂不支持问题反馈，如有问题请前往手机客户端进行反馈。")]), _vm._v(" "), _c('p', {
    staticClass: "des-light"
  }, [_vm._v("反馈路径：58APP-我的-我的求职-会员中心-专属客服-填写反馈")])])]), _vm._v(" "), _c('div', {
    staticClass: "downloadQRcode"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5927f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/ZskfDialog.vue
// module id = EZFi
// module chunks = 1